import { getMoney } from '@hlj/hlj-utils'
import React from 'react'
import Attachments from '@common/Attachments'

export default [
  {
    dataIndex: 'orderNo',
    title: '合作订单号'
  },
  {
    dataIndex: 'userName',
    title: '姓名'
  },
  {
    dataIndex: 'userPhone',
    title: '电话'
  },
  {
    dataIndex: ['property', 'name'],
    title: '需求类型'
  },
  {
    dataIndex: ['merchant', 'name'],
    title: '商家名'
  },
  {
    dataIndex: 'totalMoney',
    title: '订单金额',
    render: totalMoney => {
      return getMoney(totalMoney)
    }
  },
  {
    dataIndex: 'orderText',
    title: '订单信息',
    render: (o, { orderText, attachments }) => {
      return (
        <div>
          <div>{orderText}</div>
          <Attachments showUpload={false} value={attachments} />
        </div>
      )
    }
  },
  {
    dataIndex: ['merchantSupport', 'nick'],
    title: '创建人'
  },
  {
    dataIndex: 'createdAt',
    title: '创建时间'
  },
  {
    dataIndex: ['experienceMerchant', 'name'],
    title: '合作体验店'
  }
]
